import service from './service';
import { trimString } from '../utils/common';

export default {
  getApplyJobs(params) {
    params = trimString(params)
    return service.get('/api/v1/applying-jobs', { params });
  },
  delApplyJobs(id) {
    return service.post(`/api/v1/unapplying-jobs/${id}`);
  }
};



// WEBPACK FOOTER //
// ./src/api/personal-sendlog.js